<template>
    <div>
        <el-form :inline="true">
            <el-form-item label="用户(userId/账号)">
                <el-input v-model="queryCondition.userId"></el-input>
            </el-form-item>
            <el-form-item label="交易对">
                <el-input v-model="queryCondition.pair"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryCondition.page=1,queryMachineProject()">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="insert = !insert">{{insert ? '取消' : '新增'}}</el-button>
            </el-form-item>
            <el-form-item v-if="insert">
                <el-input v-model="projectUserId" placeholder="新增项目方userId/账号"></el-input>
            </el-form-item>
            <el-form-item v-if="insert">
                <el-input v-model="projectPair" placeholder="新增项目方交易对"></el-input>
            </el-form-item>
            <el-form-item v-if="insert"><el-button type="success" @click="insertMachineProject()">确认提交</el-button></el-form-item>
        </el-form>

        <el-table :data="machineProjectInfo">
            <el-table-column label="用户" prop="userId"></el-table-column>
            <el-table-column label="交易对" prop="pair"></el-table-column>
            <el-table-column label="铺单机器人">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.spreadOrder" active-color="#13ce66" inactive-color="#ff4949" @change="updateMachineProject(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="平滑机器人">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.autoDeal" active-color="#13ce66" inactive-color="#ff4949" @change="updateMachineProject(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="冰山策略">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.iceberg" active-color="#13ce66" inactive-color="#ff4949" @change="updateMachineProject(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="定时操盘">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.stockTrade" active-color="#13ce66" inactive-color="#ff4949" @change="updateMachineProject(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="关闭项目方">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.machineProject" active-color="#13ce66" inactive-color="#ff4949" @change="updateMachineProject(scope.row)"></el-switch>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="infoTotal" :page-size="15" :current-page="queryCondition.page"
                       @current-change="queryMachineProject"></el-pagination>

    </div>
</template>

<script>
    import api from './api';
    export default {
        name: "machineProject",
        data(){
            return {
                queryCondition:{
                    page:1,
                    size:15,
                    userId:'',
                    pair:''
                },
                infoTotal:0,
                machineProjectInfo:[],
                projectUserId:'',
                projectPair:'',
                insert:false
            }
        },
        methods:{
            queryMachineProject(){
                api.queryMachineProjectInfo(this.queryCondition).then(response => {
                    this.machineProjectInfo = response.data.list;
                    this.infoTotal = response.data.totalCount;
                })
            },
            updateMachineProject(row){
                api.updateMachineProjectInfo(row).then(() =>{
                    this.queryMachineProject();
                })
            },
            insertMachineProject(){
                if (!this.projectUserId){
                    this.$message.error('新增项目方账号不能为空');return;
                }
                if (!this.projectPair){
                    this.$message.error('新增项目方交易对不能为空');return;
                }
                let data = {username:this.projectUserId,pair:this.projectPair};
                api.insertMachineProjectInfo(data).then(() =>{this.$message.success('新增项目方成功'); this.queryMachineProject();})
            }
        },

        created() {
            this.queryMachineProject();
        }
    }
</script>

<style scoped>

</style>